module.exports = __webpack_public_path__ + "static/L5Y3-b9cb437c35cf9fd0002f989782c24cd3.jpg";